import { useEffect, useRef, useState } from "react"
import { ServicesTab } from "../../ServicesTab/ServicesTab.Component"
import { useDispatch, useSelector } from "react-redux"
import { onboardFormActions } from "../../../store/onboardFormState"
import { getImageUrl } from "../../../utils/images"

export const SelectServiceModal = ({ show, close, domain }) => {
    const domainId = domain?.id ?? ""
    const domainName = domain?.name ?? ""
    const services = domain?.subCategory ?? []
    const downloadRef = useRef(null);

    const [selectedServices, setSelectedServices] = useState([])
     const [isAuditFlag, setIsAuditFlag] = useState(false)

    const selectedDomains = useSelector(state => state.onboardForm.domains)

    const dispatch = useDispatch()

    const onSelectedServices = () => {
        localStorage.setItem("isAuditFlag",isAuditFlag)
        const domain = {
            id: domainId,
            name: domainName,
            subCategory: selectedServices
        }
        dispatch(onboardFormActions.setDomain(domain));
      
        close(false)
    }

    useEffect(() => {
        if (show) {
            document.getElementsByTagName("body")?.[0]?.classList.add("modal-open")
            setTimeout(() => {
                document.getElementById("select-your-services")?.classList.add("show")
            }, 100)
        }
        else {
            document.getElementsByTagName("body")?.[0]?.classList.remove("modal-open")
        }
        setSelectedServices([])
        selectedDomains.forEach(d => {
            if (d.id == domainId) {
                setSelectedServices(d.subCategory)
            }
        })


    }, [show])

     useEffect(() => {
  const isAuditFlag = selectedServices.some(service =>
  ["audit", "assurance"].every(keyword =>
    service.name.toLowerCase().includes(keyword)
  )
);
        setIsAuditFlag(isAuditFlag)
    if (isAuditFlag) {
      // Smooth scroll to the download section
      downloadRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });

      // Add highlight animation temporarily
       downloadRef.current?.classList.add("shake");
       setTimeout(() => {
        downloadRef.current?.classList.remove("shake");
      }, 600); 
    }
  }, [selectedServices]);

    return (
        show ? <div>
            <div
                className={`modal p-0 fade`}
                id="select-your-services"
                style={{ display: "block" }}
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-right">
                    <div className="modal-content">
                        <div className="modal-body pa-50">
                            <p className="mb-1 font-20 font-md-30 font-weight-800">
                                Domain Services
                            </p>
                            <p className="opacity-70">
                                Please select your services
                            </p>
                            <div className="my-4">
                                <p className="text-default font-12 font-weight-700">
                                    For {domainName}
                                </p>
                                <div className="row">
                                    {
                                        services.map(service =>
                                            <ServicesTab key={service.id} service={service} selected={selectedServices} setSelected={setSelectedServices} />
                                        )}
                                </div>
               {isAuditFlag &&    <div
        
          style={{
            marginTop: "20px",
            padding: "15px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            background: "#f8f9fa"
          }}
        >
          <strong>Note:</strong>  
          <p style={{ marginTop: "8px", lineHeight: "22px" }}>
           Please download the 
            <strong> Audit Firm Document</strong> from the link below, complete it, sign it, and upload it during the Document Upload step of registration, along with any supporting documents based on your chosen options.
          </p>

          {/* Download Link */}
          <a
            ref={downloadRef}
            href={getImageUrl("dcc_registration_application_form_for_audit_firms")}
            target="_blank"
            rel="noopener noreferrer"
            className="download-link"
          >
            ⬇️ Download Audit Firm Registration Form
          </a>
        </div>}
            
                            </div>
                            <div className="mt-100">
                                <button type="button" className="btn btn-default" onClick={onSelectedServices}>
                                    Select
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light ml-3"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                        setSelectedServices([])
                                        close(false)
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal-backdrop fade ${show && "show"}`} />

        </div> : <div></div>
    )

}